module.exports = __webpack_public_path__ + "static/media/ajax.9d20228b.png";